<template>
  <div class="header">
    <el-button type="danger" class="logout" @click="handleLogout">
      <el-icon><SwitchButton /></el-icon>
      退出登录
    </el-button>
  </div>
  <div class="examinee-home">
    <h2>你好9999，{{ userInfo.name }}</h2>
    <el-row :gutter="20" justify="center">
      <el-col :span="8" v-for="exam in exams" :key="exam.examid">
        <el-card class="exam-card" shadow="hover">
          <div class="exam-info">
            <h3>{{ exam.examSubject }}
              <span class="exam-status has-submit" v-if="exam.status === 'SUBMITTED'">已提交</span>
              <span class="exam-status has-late" v-else-if="isLate(exam.examEndTime)">已迟到</span>
              <span class="exam-status on-exam" v-else-if="isNow(exam.examStartTime, exam.examEndTime)">考试中</span>
            </h3>
            <p><strong>职业（工种）：</strong> {{ exam.examType.examTypeName }}</p>
            <p><strong>考试日期:</strong> {{ formatDate(exam.examDate) }}</p>
            <p><strong>考试时间:</strong> {{ formatTimeRange(exam.examStartTime, exam.examEndTime) }}</p>
            <p><strong>考试科目:</strong> {{ exam.examSubject }}</p>
            <p><strong>考试地点:</strong> {{ exam.examLocation }}</p>
          </div>
          <div class="exam-actions">
            <el-button 
                type="primary" 
                @click="startExam(exam)"
                style="width: 100%"
                :disabled="exam.status === 'SUBMITTED' || !isNow(exam.examStartTime, exam.examEndTime)">{{ getCountdown(exam.examStartTime, exam.examEndTime) }}</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElCard, ElButton, ElRow, ElCol, ElMessage, ElIcon } from 'element-plus';
import { SwitchButton } from '@element-plus/icons-vue';
import { mapActions } from 'vuex';
// import api from '@/utils/api';

export default {
  name: 'ExamineeHome',
  components: {
    ElCard,
    ElButton,
    ElRow,
    ElCol,
    ElIcon,
    SwitchButton
  },
  data() {
    return {
      exams: [], // 存储考试信息
      userInfo: {},
      currentTime: new Date(),
      intervalId: null
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')); // 从本地存储中获取考生信息
    this.fetchExamineeInfo();
    this.updateCurrentTime();
    this.intervalId = setInterval(this.updateCurrentTime, 1000);
  },
  methods: {
    ...mapActions(['updateJoinedExam']),
    fetchExamineeInfo() {
      // const uid = this.userInfo ? this.userInfo.uid : null;
      // api.getExamineeExams(uid).then(response => {
      //   console.log('获取考试信息成功:', response.data);
      //   this.exams = response.data;
      //   localStorage.setItem('examineeInfo', JSON.stringify(this.exams));
      // }).catch(error => {
      //   console.error('获取考生信息失败:', error);
      // });
      // console.log(api, uid)
      fetch("fakeApi/getExamineeExams.json").then(response => {
        if (!response.ok) {
          throw new Error('网络响应不正常');
        }
        return response.json();
      }).then(response => {
        console.log('获取考试信息成功:', response.data);
        this.exams = response.data;
        localStorage.setItem('examineeInfo', JSON.stringify(this.exams));
        for(let exam of this.exams) {
          let examid = exam.examid;
          if(sessionStorage.getItem(`submit_exam:${examid}`) === 'true') {
            exam.status = 'SUBMITTED'
          }
          exam.examDate = new Date().toISOString();
      }
      }).catch(error => {
        console.error('获取考生信息失败:', error);
      });
    },
    handleLogout() {
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload(true);
      ElMessage.success('退出登录成功');
      this.$router.push('/student-login');
    },

    startExam(exam) {
      this.updateJoinedExam(exam);
      this.$router.push({ path: `/confirmPage` });
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(date).toLocaleDateString(undefined, options);
    },
    formatTimeRange(startTime, endTime) {
      const options = { hour: '2-digit', minute: '2-digit' };
      const start = new Date(startTime).toLocaleTimeString(undefined, options);
      const end = new Date(endTime).toLocaleTimeString(undefined, options);
      return `${start} ~ ${end}`;
    },
    isLate(examEndTime) {
      return this.currentTime > new Date(examEndTime);
    },
    isNotOnTime(examStartTime) {
      return this.currentTime < new Date(examStartTime);
    },
    isNow(startTime, endTime) {
      const examStartTime = new Date(startTime);
      const examEndTime = new Date(endTime);
      return this.currentTime >= examStartTime && this.currentTime <= examEndTime;
    },
    updateCurrentTime() {
      this.currentTime = new Date();
      // 如果需要，您可以在这里执行其他操作
    },
    getCountdown(examStartTime, examEndTime) {
      const start = new Date(examStartTime).getTime();
      const end = new Date(examEndTime).getTime();
      const current = this.currentTime.getTime();

      if (isNaN(start) || isNaN(end)) {
        return '无效的考试时间';
      }

      if (current < start) {
        // 当前时间早于开始时间，显示倒计时到开始时间
        const remaining = start - current;
        const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remaining / (1000 * 60)) % 60);
        const seconds = Math.floor((remaining / 1000) % 60);
        return `${days}天${hours}小时${minutes}分钟${seconds}秒`;
      } else if (current > end) {
        // 当前时间晚于结束时间，显示考试结束
        return "考试结束";
      } else {
        // 当前时间在开始时间和结束时间之间，显示倒计时到结束时间
        return "开始考试";
      }
    }
  },
  onUnmounted() {
    clearInterval(this.intervalId);
  }
};
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #70a1f8;
  color: #fff;
  padding: 10px 20px;
  height: 5%;
  flex-direction: row-reverse;
}

.logout {
  background-color: #ff4d4f;
  float: right;
}
.examinee-home {
  padding: 20px;
  text-align: center;
  background-color: #f0f2f5;
}

h2 {
  margin-bottom: 20px;
  color: #333;
}

.exam-card {
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s;
  position: relative;
}

.exam-card:hover {
  transform: translateY(-5px);
}

.exam-info {
  margin-bottom: 20px;
  text-align: left;
}

.exam-info h3 {
  color: #409eff;
}

.exam-status {
  position: absolute;
  right: 20px;
  top: 20px;
  transform: rotate(45deg);
  transform-origin: bottom;
}

.has-submit {
  color: #28A745;
}

.has-late{
  color: #FFA500;
}

.on-exam{
  color: #6F42C1;
}

.exam-info p {
  margin: 5px 0;
}

.exam-actions {
  text-align: right;
}
</style>
